import { render, staticRenderFns } from "./SignEventDetails.vue?vue&type=template&id=5dfa7b82&"
import script from "./SignEventDetails.vue?vue&type=script&lang=js&"
export * from "./SignEventDetails.vue?vue&type=script&lang=js&"
import style0 from "./SignEventDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports